export class WeekDayModel {
  WeekIndex: number;
  WeekDate: string;
  Monday: string;
  Tuesday: string;
  Wednesday: string;
  Thursday: string;
  Friday: string;
}
